import React, { useState } from "react";
import { Button, Card, Container } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import img2 from "../../assets/hotelimg1.jpg"

const bedTypeData = [
    {
        name: "King / Twin",
        image: img2,
    },
    {
        name: "Single Bed",
        image: img2,
    },
    {
        name: "Twin Two Separate Bed",
        image: img2,
    },
    {
        name: "1 Double Bed Room 1-Single Bed (Triple Bed Room)",
        image: img2,
    },
    {
        name: "King Bed",
        image: img2,
    },
    {
        name: "Queen Bed",
        image: img2,
    },
];

export default function BedType() {
    const navigate = useNavigate();

    const pageLimit = 25;
    const [currentPage, setCurrentPage] = useState(1);

    const totalPages = Math.ceil(bedTypeData.length / pageLimit);
    const startIndex = (currentPage - 1) * pageLimit;
    const paginatedData = bedTypeData.slice(
        startIndex,
        startIndex + pageLimit
    );

    return (
        <>

            <div className="breadcrumb-bar mb-2">
                <div className="breadcrumb-left">
                    <Link to="/admin/home" className="breadcrumb-link active">
                        Home
                    </Link>

                    <span className="breadcrumb-separator">|</span>

                    <span className="breadcrumb-link inactive" onClick={() => navigate("/admin/bedtype")}> BedType</span>
                </div>

                {/* Right: Button */}
                <Button
                    className="add-outlet-btn"
                    onClick={() => navigate("/admin/addbed-type")}
                >
                    + Add Bed Type
                </Button>
            </div>

            <Container fluid>

                <Card style={{ border: "none" }}>
                    <h4 className="mx-4 my-4">Bed Type List</h4>

                    <Card.Body>
                        <div className="common-table-wrapper">
                            <table className="common-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: "80px" }}>#</th>
                                        <th>Bed Type</th>
                                        <th style={{ width: "140px", textAlign: "center" }}>Icon</th>
                                        <th style={{ width: "120px", textAlign: "center" }}>
                                            Action
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {paginatedData.length === 0 ? (
                                        <tr>
                                            <td colSpan="4" className="text-center py-4 text-muted">
                                                No Data Found
                                            </td>
                                        </tr>
                                    ) : (
                                        paginatedData.map((item, index) => (
                                            <tr key={index}>
                                                <td>{startIndex + index + 1}</td>

                                                <td className="text-muted">{item.name}</td>

                                                <td style={{ textAlign: "center" }}>
                                                    <img
                                                        src={item.image}
                                                        alt={item.name}
                                                        style={{
                                                            width: "80px",
                                                            height: "56px",
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                            border: "1px solid #e5e7eb",
                                                        }}
                                                    />
                                                </td>

                                                <td>
                                                    <Link to="/editbed-type">
                                                        <Button className="icon-btn edit">
                                                            <FaEdit />
                                                        </Button>
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>

                            {totalPages > 1 && (
                                <div className="d-flex justify-content-end gap-2 p-3">
                                    <Button
                                        size="sm"
                                        variant="light"
                                        disabled={currentPage === 1}
                                        onClick={() => setCurrentPage((p) => p - 1)}
                                    >
                                        Prev
                                    </Button>

                                    {[...Array(totalPages)].map((_, i) => (
                                        <Button
                                            key={i}
                                            size="sm"
                                            variant={
                                                currentPage === i + 1 ? "primary" : "light"
                                            }
                                            onClick={() => setCurrentPage(i + 1)}
                                        >
                                            {i + 1}
                                        </Button>
                                    ))}

                                    <Button
                                        size="sm"
                                        variant="light"
                                        disabled={currentPage === totalPages}
                                        onClick={() => setCurrentPage((p) => p + 1)}
                                    >
                                        Next
                                    </Button>
                                </div>
                            )}
                        </div>
                    </Card.Body>
                </Card>
            </Container>
        </>
    );
}
